<template>
    <div
        v-if="model.value"
        :id="model.id"
        class="speech-bubble-container"
    >
        <div class="primary-content">
            <dynamic-resize-container
                class="speech-bubble"
            >
                <template
                    #default="{width}"
                >
                    <speech-bubble
                        :value="valueString"
                        :size="width"
                    />
                </template>
            </dynamic-resize-container>
            <div class="label">
                <div class="inline-block">
                    {{ label }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DynamicResizeContainer from '@/components/DynamicResizeContainer.vue';
import SpeechBubble from '@/components/SpeechBubble.vue';
import MetricChartModel from '@/model/MetricChartModel';

export default {
    components: {
        DynamicResizeContainer,
        SpeechBubble
    },
    props: {
        model: {
            type: MetricChartModel,
            required: true
        }
    },
    computed: {
        valueString() {
            return this.model.format(this.model.value);
        },
        label() {
            return `of people ${this.model.valueLabel ? `in ${this.model.valueLabel}` : ''} ${this.model.label}`;
            // return 'of people in Sturgeon County West believe tobacco use impacts cancer risk a lot';
        }
    }
};
</script>

<style src="./common.container.css" scoped></style>
<style lang="postcss" scoped>

.primary-content {
    @apply flex flex-row justify-around items-end;
}

.speech-bubble {
    @apply flex-grow self-start w-1/3;
    min-width: 100px;
    max-width: 125px;
}

.label {
    @apply flex-grow w-2/3 pl-4 text-neutral-label text-base leading-tight font-normal;
}
</style>
